import axios from "axios";

export default {
  namespaced: true,
  state: {
    file: null,
    files: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    filesMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    RECEIVED_FILES(state, payload) {
      state.file = payload;
      state.isReceiving = false;
    },
    RECEIVED_FILE(state, payload) {
      state.file = payload;
      state.isReceiving = false;
    },
    RECEIVING_FILES(state) {
      state.isReceiving = true;
    },
    RECEIVING_FILE(state) {
      state.isReceiving = true;
    },
    UPDATED_FILE(state, payload) {
      let index = state.files.findIndex(i=>i._id==payload._id);
      state = Object.assign(state, {
        files: state.files.map((file, i) => {
          if (i === index) {
            return Object.assign({}, file, payload);
          }
          return file;
        }),
        isReceiving: false,
        filesMessage: 'Files has been updating!',
      })
    },
    UPDATING_FILE(state) {
      state.isReceiving = true;
    },
    DELETED_FILE(state, payload) {
      let indexToDelete = state.files.findIndex(file => file._id === payload._id);
      let files = [...state.files];
      files.splice(indexToDelete, 1);
      state = Object.assign(state, {
        files: [...files],
        isDeleting: false,
        idToDelete: null,
        filesMessage: 'File has been Deleted!',
      });
    },
    DELETING_FILE(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async insertFileRequest({dispatch}, payload) {
      try{
        if(payload.file == undefined || payload.file == null) return;
        dispatch("receivingFiles");
        let token = localStorage.getItem('token');
        let url = `https://api.tradexc.com:3000/insert/file/${payload.route}/${payload.id}`;
        
        let data = new FormData();
        data.append('file', payload.file); 
        delete payload['id'];
        delete payload['file'];
        for (let x in payload) data.append(x, payload[x]);
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let response = await axios({method: "POST", url: url, headers: headers, data: data});
        dispatch("receiveFile", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteFileRequest({dispatch}, payload) {
      try{
        dispatch("updatingFile");
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/file/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("doNothing");
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateFileRequest({dispatch}, payload) {
      dispatch("updatingFile");
      let id = payload.id;
      delete payload['id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/file/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method: "put", url: url, headers: headers, data: payload});
      dispatch("updateFile", response.data);
      return response.data;
    },
    async getDownloadFile({dispatch}, url){
      dispatch("doNothing");
      const response = await fetch(url);
      let data = await response.blob();
      let blob = new Blob([data], { type: 'application/pdf' });
      let filesrc = URL.createObjectURL(blob);
      return filesrc;
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receivedFiles({commit}, payload) {
      commit("RECEIVED_FILES", payload)
    },
    receivingFiles({commit}) {
      commit("RECEIVING_FILES")
    },
    receiveFile({commit}, payload) {
      commit("RECEIVED_FILE", payload)
    },
    receivingFile({commit}) {
      commit("RECEIVING_FILE")
    },
    updateFile({commit}, payload) {
      commit("UPDATED_FILE", payload)
    },
    updatingFile({commit}) {
      commit("UPDATING_FILE")
    },
    deleteFile({commit}, payload) {
      commit("DELETED_FILE", payload)
    },
    deletingFile({commit}, payload) {
      commit("DELETING_FILE", payload)
    }
  },
};
